import { useEffect, useState } from "react";
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Clock } from "lucide-react";
import { api } from "@/lib/api";

const Tip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return <div className="bg-[#1A1A18] text-[#FAF8F5] text-xs px-3 py-2 rounded-md shadow-lg" data-testid="hourly-chart-tooltip">{String(d.hour).padStart(2, "0")}:00–{String(d.hour + 1).padStart(2, "0")}:00 · <strong>{d.count}</strong> test</div>;
};

export const HourlyChart = ({ period }) => {
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.get("/admin/analytics/hourly", { params: { period } }).then((r) => setData(r.data)).catch(() => setData({ hours: [], weekdays: [], top: [], best_day: null })); }, [period]);
  const topHours = new Set((data?.top || []).map((h) => h.hour));
  const total = (data?.hours || []).reduce((a, h) => a + h.count, 0);

  return (
    <div className="bg-white border border-[#E2DACF] p-6 mt-6" data-testid="analytics-hourly-chart">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <p className="text-xs text-[#8C8275]">Fasce orarie · test avviati (ora italiana)</p>
          <p className="font-serif text-2xl mt-1">Quando le clienti fanno il test</p>
        </div>
        {data?.top?.length ? (
          <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="hourly-top-slots">
            <Clock size={14} strokeWidth={1.5} className="text-[#C5A059]" />
            {data.top.map((h) => <span key={h.hour} className="px-2.5 py-1 rounded-full bg-[#F2ECE4] text-[#1A1A18] tabular-nums">{String(h.hour).padStart(2, "0")}:00–{String(h.hour + 1).padStart(2, "0")}:00 · {h.count}</span>)}
            {data.best_day && <span className="text-[#8C8275]">Giorno top: <strong className="text-[#1A1A18] font-medium" data-testid="hourly-best-day">{data.best_day.label}</strong></span>}
          </div>
        ) : null}
      </div>
      {!data ? <p className="text-sm text-[#8C8275]">Caricamento…</p> : !total ? <p className="text-sm text-[#C2B8A8]" data-testid="hourly-empty">Nessun test avviato nel periodo selezionato.</p> : (
        <>
          <div className="h-44 sm:h-52">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data.hours} margin={{ top: 8, right: 4, left: -26, bottom: 0 }} barCategoryGap="22%">
                <XAxis dataKey="hour" tickFormatter={(h) => (h % 3 === 0 ? `${String(h).padStart(2, "0")}` : "")} tick={{ fontSize: 10, fill: "#8C8275" }} tickLine={false} axisLine={{ stroke: "#E2DACF" }} interval={0} />
                <YAxis allowDecimals={false} tick={{ fontSize: 10, fill: "#8C8275" }} tickLine={false} axisLine={false} />
                <Tooltip content={<Tip />} cursor={{ fill: "#FAF8F5" }} />
                <Bar dataKey="count" radius={[3, 3, 0, 0]} isAnimationActive>
                  {data.hours.map((h) => <Cell key={h.hour} fill={topHours.has(h.hour) ? "#C5A059" : "#E6DFD5"} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="grid grid-cols-7 gap-1.5 mt-5" data-testid="weekday-strip">
            {data.weekdays.map((w) => {
              const max = Math.max(...data.weekdays.map((x) => x.count), 1);
              return (
                <div key={w.weekday} className="text-center">
                  <div className="h-1.5 rounded-full bg-[#F2ECE4] overflow-hidden"><div className="h-full bg-[#1A1A18]" style={{ width: `${(w.count / max) * 100}%` }} /></div>
                  <p className="text-[10px] text-[#8C8275] mt-1.5">{w.label.slice(0, 3)} <span className="tabular-nums text-[#1A1A18]">{w.count}</span></p>
                </div>
              );
            })}
          </div>
          <p className="text-[11px] text-[#8C8275] mt-4">In oro le 3 fasce più attive: programma post e promozioni poco prima di questi orari.</p>
        </>
      )}
    </div>
  );
};
